import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { FlashService } from "../../../flash/flash.service";
import { ErrorService } from "../../../services/error.service";
import { ExitChecklistService } from "../../../services/exit-checklist.service";
import { OffboardingService } from "../../../services/offboarding.service";

@Component({
  selector: 'app-exit-checklist-view-sysadmin',
  templateUrl: './exit-checklist-view-sysadmin.component.html',
  styleUrls: ['./exit-checklist-view-sysadmin.component.css']
})
export class ExitChecklistViewSysadminComponent implements OnInit {
  public form: FormGroup;
  currentUser;
  public fields: any[];

  tem: any;
  exp_ans = [];

  inValid: boolean = false;
  errors;
  params:any;
  answers:any;
  showform;
  public formsStatus: Object = {};
  public elementName = [];

  constructor(
    private service: ExitChecklistService,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService,
    private errorService: ErrorService,
    private router: Router,
    private route: ActivatedRoute,
    private offboardingService: OffboardingService,
  ) {}

  ngOnInit() {
     /* Taking values from the url */
    this.route.params.subscribe(
      params => {
        this.params = params
      }
    );
    this.fields = JSON.parse(sessionStorage.getItem("check_sysadmin"));
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));

    this.form = new FormGroup({});
    this.fields.forEach((x) => {
      if (x.type == "checkbox") {
        this.form.addControl(x.name, new FormGroup({}));
        x.options.forEach((o) => {
          (this.form.get(x.name) as FormGroup).addControl(
            o.key,
            new FormControl(false)
          );
        });
      } else {
        this.form.addControl(
          x.name,
          new FormControl(
            x.value || "",
            x.required ? Validators.required : null
          )
        );
      }
    });

    this.generateForm()
    this.getSystemAdminAnswers()
    this.getOffboardingEmployeeDetails()
  }

  getFields() {
    return this.fields;
  }

  getSystemAdminAnswers() {
    this.service.getSystemAdminAnswers(this.params.id).subscribe(
      (data) => {
        this.tem = data.body;
        this.answers = this.tem.questions;       
        if(this.answers.length > 0){
          this.showform = false;
        }else{
          this.showform = true;
        }
      },
      (err) => {
        console.log("Get System Admin Exit Checklist Answer Error:", err);
      }
    );
  }

  onSubmit() {
    //body formation below
    this.exp_ans = [];

    let keys_data = Object.keys(this.form.value);
    let value_data = Object.values(this.form.value);

    keys_data.forEach((element, index) => {
      var item = this.fields.find((item) => item.name === element);
      if ((typeof value_data[index] === "object") === true) {
        let obj = value_data[index];

        var keys = Object.keys(obj);

        var filtered = keys.filter(function (key) {
          return obj[key];
        });

        this.exp_ans.push({ name:item.name, id: item.id, ans: filtered });
      } else {
        this.exp_ans.push({ name:item.name, id: item.id, ans: value_data[index] });
      }

      if(value_data[index] === undefined){
        return this.inValid = true
     }
    });

    this.inValid = false;
    
    let obj = Object.values(this.form.value);

   obj.forEach((formValue) => {
      if (formValue === "") {
        this.inValid = true;
      }
    });

    this.elementName = [];

    this.exp_ans.forEach(ele => {
      if(!ele.ans){
        this.elementName.push(ele.name);
      }
    });

    if(this.elementName.length){
      this.inValid = true;
    }
    
    const payload = {
      emp_id: this.params.id.toString(),
      data: this.exp_ans,
    };

    if(this.inValid === false) this.submitChecklistSysadmin(payload)
  }

  cc() {
    this.exp_ans = [];

    let keys_data = Object.keys(this.form.value);
    let value_data = Object.values(this.form.value);

    keys_data.forEach((element, index) => {
      var item = this.fields.find((item) => item.name === element);

      if ((typeof value_data[index] === "object") === true) {

        var obj = value_data[index];

        var keys = Object.keys(obj);

        var filtered = keys.filter(function (key) {
          return obj[key];
        });

        this.exp_ans.push({ id: item.id, ans: filtered });
      } else {
        this.exp_ans.push({ id: item.id, ans: value_data[index] });
      }

    });

    const payload = {
      emp_id: this.params.id.toString(),
      data: this.exp_ans,
    };
  
    this.submitChecklistSysadmin(payload)
  }

  submitChecklistSysadmin(data){
    this.spinnerService.show()
    this.service.submitChecklistSysadmin(data).subscribe(
      (data) => {
        this.spinnerService.hide();
        if (data.body["success"]) {
          this.flashService.show(data.body["message"], "alert-success");
          setTimeout(()=>{                         
            this.router.navigateByUrl("offboarding");
        }, 1600);

        } else {
          this.errors = data.body["result"];
          this.flashService.show(data.body["message"], "alert-success");
          setTimeout(()=>{                         
            this.router.navigateByUrl("offboarding");
        }, 1600);
          
        }
        this.spinnerService.hide()
      },
      (error) => {
        this.spinnerService.hide();
        this.errorService.errorHandling(error);
      }
    );
  }


  generateForm() {
    this.form = new FormGroup({
      fields: new FormControl(JSON.stringify(this.fields)),
    });

    this.form = new FormGroup({});
    this.fields.forEach((x) => {
      if (x.type == "checkbox") {
        this.form.addControl(x.name, new FormGroup({}));
        x.options.forEach((o) => {
          (this.form.get(x.name) as FormGroup).addControl(
            o.key,
            new FormControl(false)
          );
        });
      } else {
        this.form.addControl(
          x.name,
          new FormControl(
            x.value || "",
            x.required ? Validators.required : null
          )
        );
      }
    });
  }

  back(){
    this.router.navigate(['/offboarding'])
  }

  getOffboardingEmployeeDetails() {
    this.spinnerService.show();
    this.offboardingService
      .getOffboardingEmployeeDetails(this.params.id)
      .subscribe(
        (data) => {
          this.formsStatus = data.body.data;
          this.spinnerService.hide();
        },
        (err) => {
          this.spinnerService.hide();
          console.log("Get Offboarding Employee Details Error:", err);
        }
      );
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/offboarding/forms-view/exit-checklist-view-sysadmin/exit-checklist-view-sysadmin.component.ts